export default "__VITE_ASSET__DYyl$vQt__"